if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.mainCart = document.querySelector('cart-items')
      this.variantId = this.form.querySelector('[name=id]').value

      this.isSyncForm = this.hasAttribute('data-sync-form'); // true if form and select quantity are sync
      this.elSelectsQtsMain = document.querySelectorAll('[data-sync-select]');

      const closestContainer = this.closest('.js-quantity-add-to-cart');

      if (closestContainer) {
        this.closestSelect = closestContainer.querySelectorAll('[data-select-quantity]');

        this.closestSelect.forEach(element => {
          element.addEventListener('change', (event) => {
            const selectedValue = event.target.value;
            this.dataset.selectActualQuantity = selectedValue; // Mise à jour de l'attribut data-select-actual-quantity
            this.manageInputQuantity(selectedValue);
          });
        });
      }

      if (document.querySelector('cart-drawer')) {
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

      }

      if (this.isSyncForm) {
        this.elSelectsQtsMain.forEach(elSelectQt => {

          elSelectQt.addEventListener('change', (event) => { // on change of select quantity update sync form and select

            this.elSelectsQtsMain.forEach(elSelectQt => {
              elSelectQt.value = event.target.value;
              this.manageInputQuantity(event.target.value);
            });

          });
        });
      }

    }

    manageInputQuantity(qty) {
      this.inputQuantity = this.querySelector('[data-input-quantity]');
      if (!this.inputQuantity) {
        this.inputQuantity = document.createElement("input");
        this.inputQuantity.type = "hidden";
        this.inputQuantity.name = "quantity";
        this.inputQuantity.setAttribute("data-input-quantity", "");
        this.form.append(this.inputQuantity)
      }
      this.inputQuantity.value = qty;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const priceVariant = this.submitButton.querySelector('[data-price-variant]');
      const loader = this.submitButton.querySelector('.loading-overlay__spinner');
      if(priceVariant) {
        priceVariant.classList.add('hidden');
      }
      if(loader) {
        loader.classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (document.querySelector("body").classList.contains("template-cart")) {
        if (this.mainCart) {
          formData.append('sections', this.getSectionsToRenderMainCart().map((section) => section.section));

          formData.append('sections_url', window.location.pathname);
        }
      } else if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
          return response.json()
        })
        .then((response) => {

          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            if (!this.mainCart) {
              window.location = window.routes.cart_url;
              return;
            }
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(response)
              });
            }, {
              once: true
            });
            quickAddModal.hide(true);
          } else {
            if (document.querySelector("body").classList.contains("template-cart")) {
              if (this.mainCart) {
                this.renderContentsMainCart(response);
                window.scrollTo(0, 0);
              }
            } else {
              this.cart.renderContents(response);
            }
          }

          this.element = this

          this.addDatalayerAddToCart(response, this.element)

          // if Klaviyo API KEY is set, so pushToKlaviyo
          const item = this.dataset?.klaviyo
          if (item) {
            this.pushToKlaviyo(this.element)
          }

          // Afficher la notification d'ajout au panier (Accessiway)
          response.key && this.showNotification(response.key);

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {

          if (window.location.pathname == '/cart') {
            this.btnClose = this.closest(".c-card-product")?.querySelector(".js-close-addtocart"); // search close btn on desktop
            if (!this.btnClose) this.btnClose = this.closest(".js-addtocart-variants")?.querySelector(".js-close-addtocart"); // search close btn on mobile
            if (this.btnClose) {
              this.btnClose.click();
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            }
          }
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');

          const priceVariant = this.submitButton.querySelector('[data-price-variant]');
          const loader = this.submitButton.querySelector('.loading-overlay__spinner');
          if(priceVariant) {
            priceVariant.classList.remove('hidden');
          }
          if(loader) {
            loader.classList.add('hidden');
          }

          const productForms = document.querySelectorAll(`input[value="${this.variantId}"]`)

          productForms.forEach(form => {
            if (this.form.querySelector('[name=id]').value === form.value) {
              this.form.querySelector('[name=id]').dispatchEvent(new Event('change', {
                bubbles: true
              }));
            }
          });


        });
    }
    // Accessiway
    showNotification(key) {
      let cartNotification = document.getElementById(`mini-cart-notif-${key}`);

      if (!cartNotification) return // page/cart do not have the notification

      cartNotification.classList.add('u-max-h-full')

      setTimeout(() => {
        cartNotification.classList.remove('u-max-h-full');
      }, 5000);
    }

    pushToKlaviyo(element) {
      window._learnq = window._learnq || [];

      const item = []
      item.currency = window.Shopify.currency.active;
      item.value = Number(element.dataset.productPrice) * Number(element.dataset.selectActualQuantity) || Number(element.dataset.productPrice);
      item.title = element.dataset.productTitle;
      item.productId = Number(element.dataset.productId);
      item.productPrice = Number(element.dataset.productPrice);
      item.productOldPrice = Number(element.dataset.productCompareAtPrice);
      item.productCoupon = element.dataset.productCoupon;
      item.productDiscount = element.dataset.productDiscount;
      item.productIndex = Number(element.dataset.index);
      item.itemCat = element.dataset.itemCategory;
      item.itemCat2 = element.dataset.itemCategory2;
      item.itemListId = Number(element.dataset.itemListId);
      item.itemListName = element.dataset.itemListName;
      item.productQuantity = Number(element.dataset.productQuantity);
      item.locationId = element.dataset.locationId;
      item.actualQuantity = Number(element.dataset.selectActualQuantity);

      _learnq.push(["track", "Added to Cart", item]);
    }

    addDatalayerAddToCart(item, element) {


      this.productTitle = element.dataset.productTitle;
      this.productId = element.dataset.productId;
      this.productPrice = element.dataset.productPrice;
      this.productOldPrice = element.dataset.productCompareAtPrice;
      this.productCoupon = element.dataset.productCoupon;
      this.productDiscount = element.dataset.productDiscount;
      this.productIndex = element.dataset.index;
      this.itemCat = element.dataset.itemCategory;
      this.itemCat2 = element.dataset.itemCategory2;
      this.itemListId = element.dataset.itemListId;
      this.itemListName = element.dataset.itemListName;
      this.productQuantity = element.dataset.productQuantity;
      this.locationId = element.dataset.locationId;
      this.actualQuantity = element.dataset.selectActualQuantity;
      this.productSelSku = element.dataset.productSelSku;

      // Force quantity = 1 when not defined for the quick add to cart without quantity selection
      if (!this.actualQuantity) {
        this.actualQuantity = 1;
      }

      const dataLayerClear = {
        ecommerce: null
      };
      window.dataLayer.push(dataLayerClear);

      const dataLayerAddToCart = {
        event: 'add_to_cart',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: Number(this.productPrice * this.actualQuantity || this.productPrice),
          value_nodiscount: Number(this.productOldPrice * this.actualQuantity || this.productPrice),
          items: [{
            item_name: String(this.productTitle),
            item_id: String(this.productId),
            item_sku: String(this.productSelSku),
            coupon: null,
            discount: Number(this.productDiscount),
            index: Number(this.productIndex || undefined),
            item_category: String(this.itemCat),
            item_category2: String(this.itemCat2),
            item_list_id: Number(this.itemListId || undefined),
            item_list_name: String(this.itemListName || undefined),
            location_id: String(this.locationId || undefined),
            price: Number(this.productPrice),
            price_nodiscount: Number(this.productOldPrice || this.productPrice),
            quantity: Number(this.actualQuantity),
          },],
        },
      };
      window.dataLayer.push(dataLayerAddToCart);

    }

    renderProductInfo() {
      const id = document.querySelector("[data-mutation-change-variant]").id;
      fetch(`${window.location.href}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");

          this.reRenderSection(html, id);
        });
    }
    reRenderSection(html, section) {
      const destinationAdd = document.getElementById(`${section}`);

      const sourceAdd = html.getElementById(`${section}`);
      if (sourceAdd && destinationAdd) destinationAdd.innerHTML = sourceAdd.innerHTML;
      const add = document.getElementById(`${section}`);

      if (add) add.classList.remove("visibility-hidden");
    }
    getSectionsToRenderMainCart() {
      return [{
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
      ];
    }

    renderContentsMainCart(parsedState) {
      this.getSectionsToRenderMainCart().forEach((section) => {
        if (!!section.section) {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTMLMainCart(
            parsedState.sections[section.section],
            section.selector,
          );
        }
      });
    }

    getSectionInnerHTMLMainCart(html, selector) {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }



    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      this.errorMessageWrapper.classList.add('u-mt-10');

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}